// AuthContext.js
import { createContext, useContext, useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
// import { useNavigate } from "react-router-dom";
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authToken, setAuthToken] = useState(Cookies.get("authToken"));
  // console.log(authToken);
  // const [user, setUser] = useState(Cookies.get("user"));
  useEffect(() => {
    const tokenFromCookie = Cookies.get("authToken");
    if (tokenFromCookie && !authToken) {
      setAuthToken(tokenFromCookie);
    }
  }, [authToken]);

  const sessionTimeoutDuration = 120 * 60 * 1000; // 120 minutes in milliseconds
  const timerRef = useRef(null);
  // const navigate = useNavigate();

  const startSessionTimer = () => {
    clearTimeout(timerRef.current); //
    setTimeout(() => {
      // alert(timerRef);
      logout();
    }, sessionTimeoutDuration);
  };

  const login = (token) => {
    setAuthToken(token);
    Cookies.set("authToken", token);
    Cookies.set("loginTime", new Date().getTime());
    startSessionTimer();
    // console.log(timerRef);
  };

  const logout = () => {
    Cookies.remove("authToken");
    Cookies.remove("user");
    window.location.href = "/login";
    clearTimeout(timerRef.current);
  };

  useEffect(() => {
    const tokenFromCookie = Cookies.get("authToken");
    const loginTime = Cookies.get("loginTime");
    if (tokenFromCookie && loginTime) {
      const currentTime = new Date().getTime();
      if (currentTime - parseInt(loginTime) > sessionTimeoutDuration) {
        logout();
      } else {
        setAuthToken(tokenFromCookie);
        const remainingTime =
          sessionTimeoutDuration - (currentTime - parseInt(loginTime));
        timerRef.current = setTimeout(() => {
          logout();
        }, remainingTime);
      }
    }
  }, []);
  return (
    <AuthContext.Provider value={{ authToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
